export default __webpack_public_path__ + "static/media/tn.8ab7256a.svg";